<ion-item lines='none'>
  <ion-toggle [formControl]="$any(formControl)" [id]="key">{{to.label}}
    @if (field.ta_validators?.required || field.ta_validators?.checkboxRequired) {
      <ion-text color="danger">*
      </ion-text>
    }
  </ion-toggle>
</ion-item>